import React from 'react';
import { Container, Title } from './styles';

export const CriticalErrorView = () => (
  <Container>
    <Title>The application could not load</Title>
  </Container>
);
